const IconConstants = {
    Dashboard: "mdi-gauge",
    InstitutionalAccount: "mdi-bank",
    CustomerAccount: "mdi-bank-transfer",
    LendingAccount: "mdi-bank-transfer-out",
    DepositAccount: "mdi-bank-transfer-in",
    Organisation: "mdi-office-building-outline",
    Person: "mdi-account-outline",
    Contact: "mdi-contacts-outline",
    Branch: "mdi-lan",
    Settings: "mdi-cog-tune",
    ProductSettings: "mdi-tune",
    User: "mdi-account-circle-outline",
    Role: "mdi-shield-lock-outline",
    Details: "mdi-format-columns",
    Reports: "mdi-finance",
    Create: "mdi-plus",
    Edit: "mdi-pencil",
    Override: "mdi-call-split",
    Delete: "mdi-delete",
    SendEmail: "mdi-email-edit-outline",
    ArrowRight: "mdi-arrow-right-bold-outline",
    OpenInNewWindow: "mdi-open-in-new",
    Upload: "mdi-file-upload-outline",
    Download: "mdi-file-download-outline",
    PublicData: "mdi-eye-check-outline",
    PrivateData: "mdi-eye-off-outline",
    Verified: "mdi-check-circle-outline",
    Unverified: "mdi-help-circle-outline",
    Tick: "mdi-check-outline",
    ThumbsUp: "mdi-thumb-up-outline",
    History: "mdi-history",
    Warning: "mdi-alert",
    Document: "mdi-file-document-outline",
    Cancel: "mdi-cancel",
    Webhook: "mdi-webhook",
    Api: "mdi-api",
    Schedule: "mdi-calendar-refresh",
    ScheduledFee: "mdi-calendar-clock",
    PendingFee: "mdi-calendar-search",
    RepaymentPlan: "mdi-clipboard-list-outline",
    Product: "mdi-application-edit-outline",
    ProductIssue: "mdi-application-cog-outline",
    ProductMigration: "mdi-application-export",
    AppMedium: "mdi-key-chain-variant",
    Wallet: "mdi-wallet-outline",
    Card: "mdi-credit-card-multiple-outline",
    BuySellFx: "mdi-cash-plus",
    Transactions: "mdi-format-list-bulleted-type",
    ThirdPartyAccount: "mdi-bank-plus",
    Payee: "mdi-folder-star-outline",
    PaymentOrder: "mdi-playlist-check",
    Payments: "mdi-format-list-checks",
    Mandate: "mdi-folder-arrow-right-outline",
    Configuration: "mdi-tune",
    Fee: "mdi-cash-multiple",
    RateSource: "mdi-chart-timeline-variant",
    InterestRate: "mdi-percent-outline",
    Help: "mdi-help-circle-outline",
    Compare: "mdi-file-compare",
    Association: "mdi-link-variant",
    Address: "mdi-map-marker-outline",
    Region: "mdi-map-marker-radius-outline",
    PublicHoliday: "mdi-calendar-multiselect",
    BankWithTick: "mdi-bank-check",
    BookEditOutline: "mdi-book-edit-outline",
    ArrowDecision: "mdi-arrow-decision",
    Close: "mdi-close",
    Check: "mdi-check",
    TimelineShimmer: "mdi-source-branch"
  };

  export default IconConstants;